export interface Hotel {
  id: string
  name: string
  category: 'Luxury' | 'Upscale' | 'Boutique' | 'Business'
  stars: 5 | 4 | 3
  location: string
  neighborhood: string
  image: string
  description: string
  amenities: string[]
  highlights: string[]
  priceRange: string
  contact: {
    phone: string
    email: string
    website: string
    address: string
  }
}

export const hotels: Hotel[] = [
  {
    id: 'villa-rosa-kempinski',
    name: 'Villa Rosa Kempinski',
    category: 'Luxury',
    stars: 5,
    location: 'Chiromo Road, Westlands',
    neighborhood: 'Westlands',
    image:
      'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80',
    description:
      "Nairobi's most luxurious hotel offering European elegance with African warmth. Features stunning architecture and world-class service.",
    amenities: [
      'Outdoor pool and spa',
      'Multiple restaurants and bars',
      'Fitness center',
      'Business center',
      'Concierge service',
      'Valet parking',
    ],
    highlights: [
      'Presidential suites with panoramic views',
      'Award-winning restaurants',
      'Rooftop bar',
      'Luxury spa treatments',
      'Walking distance to Westlands entertainment',
    ],
    priceRange: 'KES 35,000 - 150,000 per night',
    contact: {
      phone: '+254 20 423 0000',
      email: 'reservations.villarosa@kempinski.com',
      website: 'https://www.kempinski.com/nairobi',
      address: 'Chiromo Road, Westlands, Nairobi',
    },
  },
  {
    id: 'fairmont-norfolk',
    name: 'Fairmont The Norfolk',
    category: 'Luxury',
    stars: 5,
    location: 'Harry Thuku Road, CBD',
    neighborhood: 'CBD',
    image:
      'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800&q=80',
    description:
      'Historic luxury hotel dating back to 1904. Colonial elegance meets modern luxury in the heart of Nairobi.',
    amenities: [
      'Outdoor pool',
      'Multiple dining venues',
      'Spa and wellness center',
      'Business facilities',
      'Beautiful gardens',
      'Airport shuttle',
    ],
    highlights: [
      'Over 100 years of history',
      'Lord Delamere Terrace',
      'Central location',
      'Colonial architecture',
      'Famous afternoon tea',
    ],
    priceRange: 'KES 30,000 - 120,000 per night',
    contact: {
      phone: '+254 20 226 5000',
      email: 'norfolk@fairmont.com',
      website: 'https://www.fairmont.com/norfolk-nairobi',
      address: 'Harry Thuku Road, Nairobi',
    },
  },
  {
    id: 'hemingways-nairobi',
    name: 'Hemingways Nairobi',
    category: 'Boutique',
    stars: 5,
    location: 'Karen',
    neighborhood: 'Karen',
    image:
      'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80',
    description:
      'Intimate boutique hotel in Karen offering personalized luxury and tranquil gardens.',
    amenities: [
      'Outdoor pool',
      'Brasserie restaurant',
      'Spa services',
      'Private gardens',
      'Library lounge',
      'Complimentary WiFi',
    ],
    highlights: [
      'Only 45 rooms for intimate experience',
      'Karen location near attractions',
      'Personalized service',
      'Beautiful gardens',
      'Fine dining',
    ],
    priceRange: 'KES 25,000 - 80,000 per night',
    contact: {
      phone: '+254 20 600 0777',
      email: 'reservations@hemingways-collection.com',
      website: 'https://www.hemingways-collection.com',
      address: 'Karen, Nairobi',
    },
  },
  {
    id: 'radisson-blu',
    name: 'Radisson Blu Hotel',
    category: 'Upscale',
    stars: 5,
    location: 'Upper Hill',
    neighborhood: 'Upper Hill',
    image:
      'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80',
    description:
      'Modern upscale hotel in Upper Hill with stunning city views and excellent business facilities.',
    amenities: [
      'Rooftop pool',
      'Multiple restaurants',
      'Fitness center',
      'Meeting rooms',
      'Spa',
      'Free parking',
    ],
    highlights: [
      'Panoramic city views',
      'Close to business district',
      'Modern amenities',
      'Rooftop dining',
      'Conference facilities',
    ],
    priceRange: 'KES 20,000 - 60,000 per night',
    contact: {
      phone: '+254 20 283 9000',
      email: 'info.nairobi@radissonblu.com',
      website: 'https://www.radissonhotels.com/nairobi',
      address: 'Upper Hill, Nairobi',
    },
  },
  {
    id: 'sankara-nairobi',
    name: 'Sankara Nairobi',
    category: 'Luxury',
    stars: 5,
    location: 'Westlands',
    neighborhood: 'Westlands',
    image:
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&q=80',
    description:
      'Contemporary luxury hotel in Westlands with African-inspired design and modern amenities.',
    amenities: [
      'Rooftop pool and bar',
      'Multiple restaurants',
      'Spa and wellness',
      'Gym',
      'Business center',
      'Shopping arcade',
    ],
    highlights: [
      'Central Westlands location',
      'Contemporary African design',
      'Rooftop experience',
      'Shopping and dining',
      'Business facilities',
    ],
    priceRange: 'KES 22,000 - 70,000 per night',
    contact: {
      phone: '+254 709 011 000',
      email: 'reservations@sankara.com',
      website: 'https://www.sankara.com',
      address: 'Woodvale Grove, Westlands, Nairobi',
    },
  },
]
